<!--suppress CheckEmptyScriptTag - template required when used as mixin for root component, but there's actually no content-->
<template />
<script>
  import axios from 'axios';
  import cookies from 'vue-cookies';

  function getHeadersWithCredentials () {
    const authorization = cookies.get('Authorization');
    if (authorization)
      return {'Authorization': authorization};
    return {};
  }

  const axiosWithCredentials = axios.create({
    headers: getHeadersWithCredentials()
  });

  export default {
    name: 'AxiosHelper',

    data: () => ({
      alerts: [],
      restCallsGoing: 0
    }),

    methods: {
      usefulErrorDetail(error) {
        const detail = error.response && error.response.data || error;
        if (typeof(detail) === 'string')
          return detail;
        return JSON.stringify(detail);
      },

      doAxios(actualAxios, flowDescription, promiseFunc, dataConsumer) {
        // dataConsumer is optional... because I said so
        if (!dataConsumer)
          return this.doAxios(actualAxios, flowDescription, promiseFunc, () => {});

        this.restCallsGoing++;
        return promiseFunc(actualAxios)
          .then(response => dataConsumer(response.data))
          .catch(error => {
            const errorLog = 'Error ' + flowDescription;
            console.log(errorLog, error);
            const errorCode = error.response && error.response.status && ' (' + error.response.status + ')' || '';
            const errorDetail = this.usefulErrorDetail(error);
            this.alerts.push({type: 'warning', text: errorLog + errorCode + ': ' + errorDetail});
          })
          .then(() => this.restCallsGoing--);
      },

      credentialedAxios(flowDescription, promiseFunc, dataConsumer) {
        return this.doAxios(axiosWithCredentials, flowDescription, promiseFunc, dataConsumer);
      },

      plainAxios(flowDescription, promiseFunc, dataConsumer) {
        return this.doAxios(axios, flowDescription, promiseFunc, dataConsumer);
      }
    }
  }
</script>
